<script>
    import { timeParse } from 'd3-time-format';
    import { apnumber, pluralize, capfirst, apdate, apmonth, intcomma } from 'journalize';
    
    export let modalData;

    // write the script
    $: finding = modalData?.finding2;
    $: product_source = modalData?.source ? modalData?.source.toLowerCase() : 'state-licensed store';
    $: screening_type = modalData?.expanded_test == 'y' ? 'an expanded screening of 290 chemicals' : 'a limited screening of 66 chemicals';
    $: lab = modalData.lab;
    $: regulated_pesticides = modalData.regulated_pesticides;
    $: unchecked_pesticides = modalData.unchecked_pesticides;
    $: total_pesticides = regulated_pesticides + unchecked_pesticides;
    $: total_pesticides_txt = total_pesticides > 0 ? apnumber(total_pesticides) : 'no';
    $: regulated_pesticides_txt = regulated_pesticides > 0 ? apnumber(regulated_pesticides) : '';
    $: unchecked_pesticides_txt = apnumber(unchecked_pesticides);
    $: oil = modalData.oil;
    $: removed_from_sale = modalData.removed_from_sale;
    $: removed_from_sale_date = new Date(modalData.removed_from_sale_date+'T00:00');
    $: days_on_market = modalData.days_on_market;

    const today = new Date()

    $: oneYearAgo = today.setFullYear(today.getFullYear() - 1);

    $: removed_from_sale_date_text = (removed_from_sale_date > oneYearAgo) ? apmonth(removed_from_sale_date) + ' ' + removed_from_sale_date.getDate() : apmonth(removed_from_sale_date) + ' ' + removed_from_sale_date.getDate() + ', ' + removed_from_sale_date.getFullYear();

</script>

<p>
    This product was bought at a{product_source == 'illicit store' ? 'n' : '' } {product_source}{#if product_source == 'illicit store'}{' '}and is potentially a counterfeit product{/if}. 
            
    {#if finding == 'trace' || finding == 'nodetect'}
        {#if unchecked_pesticides > 0}
            It passed state testing criteria but was found to contain { finding == 'trace' ? 'trace levels of' : '' } pesticides that California does not monitor in cannabis, and for which no regulatory limits exist.
        {:else}
            { finding == 'trace' ? 'Trace levels of' : 'No' } pesticides were detected in {screening_type} by {lab}.
        {/if}
    {:else if finding == 'fail'}
        {#if unchecked_pesticides > 0}
            It failed state testing criteria and was found to contain pesticides that California does not monitor in cannabis, and for which no regulatory limits exist.
        {:else}
            It failed state testing criteria.
        {/if}
    {/if}

    {#if oil}
        <p>This product was found to have {oil}.</p>
    {/if}
</p>

{#if removed_from_sale}
    <p>It was removed from sale on {removed_from_sale_date_text}{#if days_on_market} {' '}after {intcomma(days_on_market)} on the market{/if}.</p>
{/if}

{#if total_pesticides > 0}
    <h4>{ capfirst(total_pesticides_txt) } pesticide{pluralize(total_pesticides)} found{#if total_pesticides > 0}:{/if}</h4>
    {#if total_pesticides > 0}
    <ul>
        {#if regulated_pesticides > 0}
        <li>{capfirst(regulated_pesticides_txt)} regulated by California Department of Cannabis Control</li>
        {/if}
        {#if unchecked_pesticides > 0}
        <li>{capfirst(unchecked_pesticides_txt)} unchecked by California, and shown in relation to EPA criteria for pesticides used on tobacco</li>
        {/if}
    </ul>
    {/if}
{/if}